<template>
    <div :class="isMobile ? 'header-m' : 'header'">
      <div v-if="currentName==='home'" class="bannerbox">
        <el-carousel :height="isMobile ? '6rem':'825px'">
          <el-carousel-item >
            <div class="banner-home banner-home-01"  @click="jumptoprod('/product')"></div>
          </el-carousel-item>
          <el-carousel-item >
            <div class="banner-home banner-home-02"  @click="jumptoprod('/plan')"></div>
          </el-carousel-item>
          <el-carousel-item >
            <div class="banner-home banner-home-03"  @click="jumptoprod('/news')"></div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="banner-about" v-else-if="currentName==='about'">
      </div>
      <div class="banner-honor" v-else-if="currentName==='gain'">
      </div>
      <div class="banner-plan" v-else-if="currentName==='plan'">
      </div>
      <div class="banner-place" v-else-if="currentName==='place'">
      </div>
      <div class="banner-product" v-else-if="currentName==='product' || currentName==='productDetail'">
      </div>
      <div class="banner-news" v-else-if="currentName==='news'">
      </div>
      <div class="banner-join" v-else-if="currentName==='join'">
      </div>
    </div>
  </template>
  
  <script>
  import imgUrl from "@/utils/imgUrl"
  export default {
    name: 'Header',
    data() {
      return {
        imgUrl,
        isMobile: window.innerWidth < 780,
        currentName: this.$route.name,
      }
    },
    mounted() {
      window.addEventListener("resize", this.initFunc)
    },
    methods: {
      initFunc() {
        this.isMobile = window.innerWidth < 780
      },
      jumptoprod(url) {
        // window.sessionStorage.setItem("scroll", 100)
        this.$router.push(url);
      },
    },
    destroyed() {
      window.removeEventListener("resize", this.initFunc)
    },
    watch: {
      "$route.path" (to, from){
        // console.log("this.$route.name", this.$route.name)
        this.currentName = this.$route.name
      }
    },
    props: {
      msg: String
    }
  }
  </script>
  
  
  <style lang="less">
    .tpopover{
      min-width: 100px !important;
      text-align: center !important;
      border-radius: 8px !important;
      position: relative;
    }
    .bannerbox{
      /deep/ .el-carousel__indicators--horizontal{
        bottom: 30px;
      }
    }
    .header{
      position: relative;
      .topNavbox{
        position: sticky;
        top: 0;
        background-color: #fff;
        z-index: 11;
      }
      .topNav{
       max-width: 1400px;
       margin: 0 auto;
      }
      .banner-home{
        height: 825px;
        width: 100%;
        background-position: center;
        background-size: 100%;
      }
      .banner-home-01{
        background: url('./../assets/banner/banner-home-01.jpg') no-repeat center 0;
      }
      .banner-home-02{
        background: url('./../assets/banner/banner-home-02.jpg') no-repeat center 0;
      }
      .banner-home-03{
        background: url('./../assets/banner/banner-home-03.jpg') no-repeat center 0;
      }
      .banner-about{
        height: 400px;
        width: 100%;
        background: url('./../assets/banner/banner-about.jpg') no-repeat center 0;
        background-position: 50%;
      }
      .banner-plan{
        height: 400px;
        width: 100%;
        background: url('./../assets/banner/banner-plan.jpg') no-repeat center 0;
        background-position: 50%;
      }
      .banner-place{
        height: 400px;
        width: 100%;
        background: url('./../assets/banner/banner-place.jpg') no-repeat center 0;
        background-position: 50%;
      }
      .banner-honor{
        height: 400px;
        width: 100%;
        background: url('./../assets/banner/banner-honor.jpg') no-repeat center 0;
        background-position: 50%;
      }
      .banner-news{
        height: 400px;
        width: 100%;
        background: url('./../assets/banner/banner-news.jpg') no-repeat center 0;
        background-position: 50%;
      }
      .banner-product{
        height: 400px;
        width: 100%;
        background: url('./../assets/banner/banner-project.jpg') no-repeat center 0;
        background-position: 50%;
      }
      .banner-join{
        height: 400px;
        width: 100%;
        background: url('./../assets/banner/banner-join.jpg') no-repeat center 0;
        background-position: 50%;
      }
      .logo {
        padding: 30px 2% 10px 4%;
        vertical-align: middle;
        img {
          width: 100%;
          display: block;
        }
      }
      .connect{
        line-height: 90px;
        .connect-one{
          display: inline-block;
          margin-right: 28px;
          .connect-one-img{
            width: 18px;
            height: 18px;
            display: inline-block;
            margin-right: 4px;
            vertical-align: middle;
          }
        }
      }
      .word{
        text-align: center;
        color: #fff;
        margin: 66px 0;
        .btn{
          background: rgb(39, 46, 55);
          border: none;
          color: #ffffffc9;
          margin: 20px;
        }
      }
    }
  
    // 移动端
    .header-m{
      text-align: left;
      .logo{
        margin: 0.2rem 0.2rem 0 0.5rem;
        img {
          width: 100%;
        }
      }
      .bannerbox{
        overflow: hidden;
      }
      .banner-home{
        height: 6rem;
        width: 100%;
        // background: url('./../assets/banner/banner-m.jpg') no-repeat center center;
        background-size: 100% 100%;
      }
      .banner-home-01{
        background: url('./../assets/banner/banner-home-01-m.jpg') no-repeat center 0;
        background-size: 100% 100%;
      }
      .banner-home-02{
        background: url('./../assets/banner/banner-home-02-m.jpg') no-repeat center 0;
        background-size: 100% 100%;
      }
      .banner-home-03{
        background: url('./../assets/banner/banner-home-03-m.jpg') no-repeat center 0;
        background-size: 100% 100%;
      }
      .banner-about{
        height: 3.6rem;
        width: 100%;
        background: url('./../assets/banner/banner-about-m.jpg') no-repeat center center;
        background-size: 100% 100%;
      }
      .banner-honor{
        height: 3.6rem;
        width: 100%;
        background: url('./../assets/banner/banner-honor-m.jpg') no-repeat center center;
        background-size: 100% 100%;
      }
      .banner-product{
        height: 3.6rem;
        width: 100%;
        background: url('./../assets/banner/banner-project-m.jpg') no-repeat center center;
        background-size: 100% 100%;
      }
      .banner-news{
        height: 3.6rem;
        width: 100%;
        background: url('./../assets/banner/banner-news-m.jpg') no-repeat center center;
        background-size: 100% 100%;
      }
      .banner-place{
        height: 3.6rem;
        width: 100%;
        background: url('./../assets/banner/banner-place-m.jpg') no-repeat center center;
        background-size: 100% 100%;
      }
      .banner-plan{
        height: 3.6rem;
        width: 100%;
        background: url('./../assets/banner/banner-plan-m.jpg') no-repeat center center;
        background-size: 100% 100%;
      }
      .banner-join{
        height: 3.6rem;
        width: 100%;
        background: url('./../assets/banner/banner-join-m.jpg') no-repeat center center;
        background-size: 100% 100%;
      }
    }

  </style>
  